// src/enum/Products.ts
export const Products: { [key: number]: string } = {
    1: "OfisPro",
    2: "İcraProWeb",
    3: "E-İcraPro",
    4: "ArabulucuPro",
    5: "DavaProWeb",
};

// Anket/değerlendirme ekranlarında kullanılan ürünler (product_id → ad)
// NOT: buradaki anahtarlar zirvebildb.product.product_id değerleridir; yukarıdaki
// `Products` (lisans/program id'leri) ile aynı sayı uzayı DEĞİLDİR.
export const SurveyProducts: { [key: number]: string } = {
    3: "ArabulucuPro",
    7: "İcraProWeb",
    8: "E-İcraPro",
};